import {
  BADGE_VALUES,
  ElementUIState,
} from '../../Controllers/UIController/UITypes';
import { waitFor } from '../../utils';
import { TutorialModule } from './TutorialModule';
import { t } from 'i18next';

export class LeagueButton extends TutorialModule {
  id = 'LeagueButton' as 'LeagueButton';

  onAction = (id?: string) => {
    this.app.ui.tooltip.hide();
    if (id === 'league') {
      this.onComplete();
    }
  };

  execute = async () => {
    this.app.ui.setTutorialUIState({
      badges: {
        mine: 0,
        earn: 0,
        friends: 0,
        boosters: 0,
        trading: BADGE_VALUES.TRADING_ALERT,
      },
    });

    this.app.ui.setClickerUIState({
      btnClicker: ElementUIState.Normal,
      btnLeague: ElementUIState.Highlight,

      footer: ElementUIState.Normal,

      btnFriends: ElementUIState.Normal,
      btnMine: ElementUIState.Normal,
      btnEarn: ElementUIState.Normal,
      btnBooster: ElementUIState.Normal,
      btnTeam: ElementUIState.Normal,
    });

    await waitFor(300);

    this.app.tutorial.showTooltip({
      text: t('tut_tooltip_league'),
      origin: { x: '50%', y: '50%' },
      offset: { x: '0px', y: '-10%' },
      align: 'top',
    });

    return super.execute().then(() => {
      this.app.ui.tooltip.hide();
      this.app.ui.setClickerUIState({ btnLeague: ElementUIState.Normal });
    });
  };

  getAnalyticsOpts() {
    return {
      key: 'FTUE_league_highlight',
    };
  }
}
